import { Box } from "@mui/material";
import { styled as muiStyled } from '@mui/material/styles';
import styled from "styled-components";

export const WrapFooterActions = styled.div`

`

export const AssessmentDefDrawerStyles = muiStyled(Box)(({ }) => ({
    width: '353px',
    display: "flex",
    flexDirection: "column",
    fontSize: '20px',
    fontWeight: 700,
    padding: 0,       // ← מחקי את padding: 20 הקיים
    '.preview-header': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        padding: 'var(--LG, 24px)',
        borderBottom: '1px solid #e0e0e0',
    },
    '.header-right': {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 8,
        color: '#404F69',
    },
    '.header-right .MuiSvgIcon-root': {
        marginTop: 5,
    },
    '.title': {
        fontSize: 22,
        fontWeight: "bold",
        display: "flex",
        alignItems: "center",
        gap: 8,
    },
    // הכותרת של התוכן צריכה padding משלה עכשיו:
    '> *:not(.preview-header)': {
        padding: '20px',
    },

}))
